import { Pipe, PipeTransform } from '@angular/core';
import { CensorService } from './censor.service';

@Pipe({ name: 'censor', standalone: true, pure: true })
export class CensorPipe implements PipeTransform {
  constructor(private censorService: CensorService) {}

  transform(text: string | null): string {
    return text ? this.censorService.censorOffensiveWords(text) : '';
  }
}
